// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../country/Currency.bs.js";
import * as AppContext from "../../../context/AppContext.bs.js";
import * as Caml_array from "../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as CountryConfig from "../../../country/CountryConfig.bs.js";
import * as Icon$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as Timestamp$Catalyst from "../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as CampaignProgressBarCmp from "./CampaignProgressBarCmp.bs.js";
import * as IncentiveAssetsManager from "../assets/styles/IncentiveAssetsManager.bs.js";
import * as CampaignMultiProgressBar from "./CampaignMultiProgressBar.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";

var infoIcon = IncentiveAssetsManager.getImage("info_icon.svg");

var circleCheck = IncentiveAssetsManager.getImage("circle_check.svg");

function IncentiveCampaignCmp$LadderBasedCampaign(Props) {
  var config = Props.config;
  var content = Props.content;
  var param_current_value = Props.param_current_value;
  var progressSatatus = Props.progressSatatus;
  var valueRange = {
    contents: param_current_value
  };
  var progressBarList = List.mapi((function (index, e) {
          var targetRange = index > 0 ? e.target - Caml_array.get($$Array.of_list(config), index - 1 | 0).target | 0 : e.target;
          var current;
          if (valueRange.contents > targetRange) {
            valueRange.contents = valueRange.contents - targetRange | 0;
            current = e.target;
          } else {
            var value = valueRange.contents;
            valueRange.contents = 0;
            current = value;
          }
          return {
                  target: e.target,
                  current: current,
                  reward: e.incentive_amount,
                  targetRange: targetRange,
                  status: progressSatatus
                };
        }), config);
  return React.createElement("div", {
              className: "ladder-progress-bar-container"
            }, React.createElement(CampaignMultiProgressBar.make, {
                  progressBarList: progressBarList,
                  labelTop: content.amount,
                  labelBottom: content.trips
                }));
}

var LadderBasedCampaign = {
  make: IncentiveCampaignCmp$LadderBasedCampaign
};

function IncentiveCampaignCmp$ValidatorCard(Props) {
  var titleText = Props.titleText;
  var targetText = Props.targetText;
  var validatorIcon = Props.validatorIcon;
  return React.createElement("div", {
              className: "trip-validator"
            }, React.createElement("div", {
                  className: "icon"
                }, React.createElement("img", {
                      src: validatorIcon
                    })), React.createElement("div", undefined, React.createElement("div", {
                      className: "completed"
                    }, titleText), React.createElement("div", {
                      className: "target"
                    }, targetText)));
}

var ValidatorCard = {
  make: IncentiveCampaignCmp$ValidatorCard
};

function IncentiveCampaignCmp$CampaignValidator(Props) {
  var validator = Props.validator;
  var content = Props.content;
  var status = Props.status;
  var validatorIcon = status !== 0 ? infoIcon : circleCheck;
  return React.createElement("div", {
              className: "trip-validator-container"
            }, React.createElement(IncentiveCampaignCmp$ValidatorCard, {
                  titleText: content.validatorCompleted,
                  targetText: content.completeTarget,
                  validatorIcon: validatorIcon
                }), ReasonReactUtils$Catalyst.listToReactArray(List.map((function (e) {
                        var match = e.validator_name;
                        var tmp;
                        switch (match) {
                          case /* MISSED_ORDER */0 :
                              tmp = content.validatorMissed;
                              break;
                          case /* ABRTG */1 :
                              tmp = content.validatorABRTG;
                              break;
                          case /* FRAUD_ORDER */2 :
                              tmp = e.threshold === 0 ? content.noFraudORders : content.froudOrders;
                              break;
                          
                        }
                        var match$1 = e.validator_name;
                        var tmp$1;
                        switch (match$1) {
                          case /* MISSED_ORDER */0 :
                              tmp$1 = content.missedTarget;
                              break;
                          case /* ABRTG */1 :
                              tmp$1 = content.abrtgTarget;
                              break;
                          case /* FRAUD_ORDER */2 :
                              tmp$1 = content.fraudOrdersAllowed;
                              break;
                          
                        }
                        return React.createElement(IncentiveCampaignCmp$ValidatorCard, {
                                    titleText: tmp,
                                    targetText: tmp$1,
                                    validatorIcon: validatorIcon
                                  });
                      }), validator)));
}

var CampaignValidator = {
  make: IncentiveCampaignCmp$CampaignValidator
};

function IncentiveCampaignCmp$ViewPerformance(Props) {
  var setShowValidators = Props.setShowValidators;
  var content = Props.content;
  var showValidators = Props.showValidators;
  return React.createElement("button", {
              className: "toggle-button",
              onClick: (function (param) {
                  return Curry._1(setShowValidators, undefined);
                })
            }, content.viewPerformance, showValidators ? React.createElement(Icon$Catalyst.ExpandLessIcon.make, {
                    className: "expand-icon",
                    fontSize: "Default"
                  }) : React.createElement(Icon$Catalyst.ExpandMoreIcon.make, {
                    className: "expand-icon",
                    fontSize: "Default"
                  }));
}

var ViewPerformance = {
  make: IncentiveCampaignCmp$ViewPerformance
};

function IncentiveCampaignCmp$TripDetails(Props) {
  var title = Props.title;
  var startDate = Props.startDate;
  var endDate = Props.endDate;
  var totalTripReward = Props.totalTripReward;
  var country = AppContext.useAppContext(undefined).countryConfig;
  var currency = CountryConfig.getCurrency(country);
  return React.createElement("div", {
              className: "trip-details"
            }, React.createElement("div", undefined, React.createElement("div", {
                      className: "title"
                    }, title), React.createElement("div", {
                      className: "duration"
                    }, startDate + " - " + endDate)), React.createElement("div", {
                  className: "trip_count"
                }, Currency.formatCurrency(totalTripReward, currency)));
}

var TripDetails = {
  make: IncentiveCampaignCmp$TripDetails
};

function IncentiveCampaignCmp(Props) {
  var campaign = Props.campaign;
  var content = Props.content;
  var match = React.useState(function () {
        return false;
      });
  var setShowValidators = match[1];
  var showValidators = match[0];
  var listLength = List.length(campaign.payout.config);
  var currentCompletedTrips = campaign.payout.param_current_value;
  var lastTarget = Caml_array.get($$Array.of_list(campaign.payout.config), listLength - 1 | 0).target;
  var match$1 = campaign.campaign_status;
  var tmp;
  switch (match$1) {
    case /* COMPLETED */0 :
        tmp = "completed";
        break;
    case /* DISQUALIFIED */1 :
        tmp = "disqualified";
        break;
    case /* IN_PROGRESS */2 :
        tmp = "in_progress";
        break;
    
  }
  var match$2 = campaign.campaign_status;
  var tmp$1;
  switch (match$2) {
    case /* COMPLETED */0 :
        tmp$1 = content.completedTitle;
        break;
    case /* DISQUALIFIED */1 :
        tmp$1 = content.disqualifiedTitle;
        break;
    case /* IN_PROGRESS */2 :
        tmp$1 = content.progressTitle;
        break;
    
  }
  var tmp$2;
  if (campaign.ladder_based) {
    var match$3 = campaign.campaign_status;
    var tmp$3;
    switch (match$3) {
      case /* DISQUALIFIED */1 :
          tmp$3 = "danger";
          break;
      case /* COMPLETED */0 :
      case /* IN_PROGRESS */2 :
          tmp$3 = "in_progress";
          break;
      
    }
    tmp$2 = React.createElement(IncentiveCampaignCmp$LadderBasedCampaign, {
          config: campaign.payout.config,
          content: content,
          param_current_value: currentCompletedTrips,
          progressSatatus: tmp$3
        });
  } else {
    var match$4 = campaign.campaign_status;
    var tmp$4;
    switch (match$4) {
      case /* DISQUALIFIED */1 :
          tmp$4 = "danger";
          break;
      case /* COMPLETED */0 :
      case /* IN_PROGRESS */2 :
          tmp$4 = "in_progress";
          break;
      
    }
    tmp$2 = React.createElement(CampaignProgressBarCmp.make, {
          target: lastTarget,
          current: currentCompletedTrips > lastTarget ? lastTarget : currentCompletedTrips,
          status: tmp$4
        });
  }
  return React.createElement("div", {
              className: "c-caimpaigns-card " + tmp
            }, React.createElement(IncentiveCampaignCmp$TripDetails, {
                  title: tmp$1,
                  startDate: Timestamp$Catalyst.toString(campaign.start_date, "DD MMM"),
                  endDate: Timestamp$Catalyst.toString(campaign.end_date, "DD MMM"),
                  totalTripReward: Caml_array.get($$Array.of_list(campaign.payout.config), listLength - 1 | 0).incentive_amount
                }), tmp$2, React.createElement("div", {
                  className: "trip_status"
                }, content.criteria), showValidators ? React.createElement(IncentiveCampaignCmp$CampaignValidator, {
                    validator: campaign.validators,
                    content: content,
                    status: campaign.campaign_status
                  }) : null, React.createElement(IncentiveCampaignCmp$ViewPerformance, {
                  setShowValidators: (function (param) {
                      return Curry._1(setShowValidators, (function (param) {
                                    return !showValidators;
                                  }));
                    }),
                  content: content,
                  showValidators: showValidators
                }));
}

var make = IncentiveCampaignCmp;

export {
  infoIcon ,
  circleCheck ,
  LadderBasedCampaign ,
  ValidatorCard ,
  CampaignValidator ,
  ViewPerformance ,
  TripDetails ,
  make ,
  
}
/* infoIcon Not a pure module */
